export const truncateStringValue = (value: string, maxLength: number = 32) => {
  if (value.length <= maxLength) {
    return value;
  }
  return value.slice(0, maxLength) + "...";
};
